<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { AdvancedCardV2, LabelV2 } from '@Shelly/shelly-design-system';
	import type { FlowCatalogCard } from '../../core/catalog/flow-card-catalog';

	export let card: FlowCatalogCard;
	export let isPremium = false;

	const dispatch = createEventDispatcher<{ select: FlowCatalogCard }>();

	$: isLocked = (card.premiumOnly && !isPremium) || !card.availability.available;
	$: status = card.premiumOnly
		? $format('label_premium', { default: 'Premium' })
		: !card.availability.available
			? card.availability.label || $format('label_unavailable', { default: 'Unavailable' })
			: '';
	$: subtitle = [...new Set([card.identity, ...card.breadcrumbs])].join(' · ');
	$: cardIcon = card.icon.includes(' ') ? card.icon : `fas ${card.icon}`;

	function selectCard() {
		if (!isLocked) dispatch('select', card);
	}
</script>

<div class:locked={isLocked} class="catalog-card-result" aria-disabled={isLocked}>
	<AdvancedCardV2
		class="catalog-result-card"
		title={card.title}
		subtitle={{ value: subtitle, bold: false }}
		description={{ value: card.sentence, bold: false }}
		avatar={{ icon: cardIcon }}
		isCondensed
		isFocusable={!isLocked}
		aria-label={$format('label_add_flow_card', {
			default: 'Add {card}',
			values: { card: card.sentence },
		})}
		hideSlotRightBadge={!status}
		on:click={selectCard}
	>
		{#if status}
			<LabelV2
				slot="rightBadge"
				size="s"
				value={status}
				type={card.premiumOnly ? 'warning' : 'disabled'}
			/>
		{/if}
	</AdvancedCardV2>
</div>

<style>
	.catalog-card-result.locked {
		opacity: 0.6;
	}
	:global(.catalog-result-card) {
		width: 100%;
	}
</style>
